// extracted by mini-css-extract-plugin
export var printerCard = "_fj-1";
export var printerCardConfigured = "_fj-2";
export var printerCardError = "_fj-3";
export var printerCardsContainer = "_fj-0";
export var printerIcon = "_fj-8";
export var printerIconConfigured = "_fj-5";
export var printerIconContainer = "_fj-4";
export var printerIconError = "_fj-6";
export var printerIconUnconfigured = "_fj-7";
export var workstationsTableCard = "_fj-9";